import { useEffect } from "react";
import { Toast } from "radix-ui";
import ToastContent from "../../molecules/toast/ToastContent";
import { useToast } from "../../../hooks/useToast";

const ToastMessage = () => {
  const { toast, hideToast } = useToast();

  useEffect(() => {
    if (toast.open) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [toast.open]);

  return (
    <Toast.Provider swipeDirection="right" duration={3000}>
      {toast.open && <div className="fixed inset-0 bg-black/50 z-10" />}
      <Toast.Root
        open={toast.open}
        onOpenChange={hideToast}
        className="relative z-20 bg-white p-4 md:p-6 max-[767px]:rounded-lg md:rounded-none"
      >
        <ToastContent type={toast.type} message={toast.message} />
      </Toast.Root>
      <Toast.Viewport
        className="
          fixed flex flex-col z-20
          top-28
          right-0
          w-1/3 max-w-[100vw]
          md:top-[80px] md:w-full
          lg:top-8 lg:w-1/3
          max-[767px]:w-[90%] max-[767px]:left-1/2 max-[767px]:-translate-x-1/2
        "
      />
    </Toast.Provider>
  );
};

export default ToastMessage;
